/** Чистые расчёты послераундового экрана. Все сроки приходят от сервера. */
export function postRoundStageAt(state, now) {
  if (!state) return "";
  if (state.phase === "CLOSED" || state.phase === "REMATCH") return "";
  if (now < state.signalEndsAt) return "signal";
  if (now < state.revealAt) return "suspense";
  if (state.replayAvailable && now < (state.replayEndsAt ?? state.clipEndsAt)) return "reveal";
  if (now < (state.holdEndsAt ?? state.clipEndsAt)) return "hold";
  return "chat";
}

export function remainingSeconds(deadline, now) {
  return Math.max(0, Math.ceil((Number(deadline) - now) / 1000));
}

export function rematchElapsed(deadline, now) {
  return Math.min(1, Math.max(0, 1 - (Number(deadline) - now) / 15000));
}

export function validReplay(value) {
  if (!value || !value.available || !Array.isArray(value.frames) || value.frames.length !== 60 ||
      value.keyFrameIndex !== 59 || !(value.durationMs > 0 && value.durationMs <= 8500)) return false;
  let previous = -Infinity;
  for (const frame of value.frames) {
    if (!Number.isFinite(frame.timestamp) || frame.timestamp <= previous ||
        typeof frame.image !== "string" || !frame.image.startsWith("data:image/jpeg;base64,")) return false;
    previous = frame.timestamp;
  }
  return value.frames[59].timestamp - value.frames[0].timestamp <= value.durationMs;
}

export function replayFrameAt(frames, elapsedMs) {
  if (!frames.length) return -1;
  const start = frames[0].timestamp;
  let index = 0;
  while (index + 1 < frames.length && frames[index + 1].timestamp - start <= elapsedMs) index += 1;
  return index;
}

export const POST_ROUND_NOTICES = Object.freeze({
  NO_RESPONSE: "Ответ не получен",
  OPPONENT_LEFT: "Соперник вышел",
  DECLINED: "Соперник отказался от реванша",
  CANCELLED: "Предложение реванша отменено",
  REMATCH_UNAVAILABLE: "Реванш недоступен",
  SESSION_UNAVAILABLE: "Послераундовая связь недоступна",
});

/** Real recording time is mapped into the shared two-second playback window. */
export function replayElapsedAt(replay, state, now) {
  const end = state.replayEndsAt ?? state.clipEndsAt;
  const duration = Math.max(1, end - state.revealAt);
  const progress = Math.min(1, Math.max(0, (now - state.revealAt) / duration));
  const sourceDuration = replay.frames[replay.keyFrameIndex].timestamp - replay.frames[0].timestamp;
  return progress * sourceDuration;
}

export function validReplayRegion(region) {
  return !!region && ["x", "y", "width", "height"].every(key => Number.isFinite(region[key])) &&
    region.x >= 0 && region.y >= 0 && region.width > 0 && region.height > 0 &&
    region.x + region.width <= 1.00001 && region.y + region.height <= 1.00001;
}

/** Center the feature in the actual contained image, including portrait/landscape letterboxing. */
export function replayZoomTransform(region, progress, boxRatio = 1, imageRatio = 1) {
  if (!validReplayRegion(region)) return "none";
  const t = Math.min(1, Math.max(0, progress));
  const eased = t * t * (3 - 2 * t);
  const scale = 1 + (Math.min(2.5, Math.max(1.5, 0.72 / region.width)) - 1) * eased;
  const fittedWidth = Math.min(1, imageRatio / boxRatio);
  const fittedHeight = Math.min(1, boxRatio / imageRatio);
  const dx = (0.5 - region.x - region.width / 2) * fittedWidth * scale * eased * 100;
  const dy = (0.5 - region.y - region.height / 2) * fittedHeight * scale * eased * 100;
  return `translate(${dx.toFixed(3)}%, ${dy.toFixed(3)}%) scale(${scale.toFixed(4)})`;
}
